export default function FooterAfterSubmit({ contractId, accountId, onClose, infoModalTrigger }) {
  function closeFormAfterSubmitMeterReading() {
    if (infoModalTrigger) {
      infoModalTrigger = false;

      var attentionContent = '<div class="modal-1 attention-modal testimony-modal page__testimony-modal"><button class="modal-1__close-btn" aria-label="Закрыть" data-fancybox-close=""><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6663 4.27333L11.7263 3.33333L7.99967 7.06L4.27301 3.33333L3.33301 4.27333L7.05967 8L3.33301 11.7267L4.27301 12.6667L7.99967 8.93999L11.7263 12.6667L12.6663 11.7267L8.93967 8L12.6663 4.27333Z" fill="black"></path></svg></button><div class="modal-1__header"><h2 class="modal-1__title">Уважаемый абонент!</h2></div><div class="modal-1__section"><div class="attention-modal__text">Вы можете сэкономить до 10%, передавая показания и одновременно производя оплату через мобильное приложение «Платосфера» с 23 по 26 число.</div><div class="attention-modal__info">Рекомендуем производить оплату в момент передачи показаний.</div><div class="attention-modal__link"><a href="https://www.nskes.ru/programma-loyalnosti-energobonus/" target="_blank">Подробные условия программы лояльности</a></div><div class="attention-modal__button"><span>Выйти</span></div></div></div>';
      $.fancybox.open(attentionContent, {
        touch: false,
        beforeClose: function () {
        }
      });
    } else {
      onClose();
    }
  }

  return (
    <div class="modal-1__section">
      <div class="testimony-modal__confirm">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 3C9.72 3 3 9.72 3 18C3 26.28 9.72 33 18 33C26.28 33 33 26.28 33 18C33 9.72 26.28 3 18 3ZM18 30C11.385 30 6 24.615 6 18C6 11.385 11.385 6 18 6C24.615 6 30 11.385 30 18C30 24.615 24.615 30 18 30Z" fill="#1A47A9" />
          <path d="M24.885 11.3695L15 21.2545L11.115 17.3845L9 19.4995L15 25.4995L27 13.4995L24.885 11.3695Z" fill="#1A47A9" />
        </svg>
        Показания внесены
      </div>
      <button class="button-primary modal-1__button"
        data-reach-goal="debts_oplata"
        data-modal-url={'/order/contract-pay/?contractId=' + contractId + '&accountId=' + accountId}
      >
        Ок, оплатить
      </button>

      <button class="button-secondary modal-1__button" onClick={closeFormAfterSubmitMeterReading}>
        Закрыть
      </button>
    </div>
  );
}
